import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

import { Validatable } from '../../../validations/validatable'
import { FormValidationService } from '../../../validations/form-validation-service'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'

import { EmailAddressTextFieldValidator } from '../../../validations/email-address-text-field-validator'
import { PhoneNumberInputMask } from '../../../common/input-masks/phone-number.input-mask'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'

import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { ValidatedCheckboxComponent } from '../../../validations/validated-checkbox.component'

import { UserProfile } from '../../models/user-profile'
import { User } from '../../models/user'

import { CommissionLevelGateway } from '../../gateways/commission-level-gateway'

@Component({
    selector: 'UserProfileComponent',
    templateUrl: 'user-profile-component.html',
    styleUrls: ['./user-profile-component.scss']
})
export class UserProfileComponent extends Validatable<User> implements OnInit {
    // @Input() disabled = false
    @Output() onValueChange: EventEmitter<User> = new EventEmitter<User>()

    @Output() onAddProfile: EventEmitter<User> = new EventEmitter<User>()

    emailValidator = new EmailAddressTextFieldValidator()
    phoneNumberInputMask = new PhoneNumberInputMask()
    lengthValidator = new LengthTextFieldValidator(10)
    numericValidator = new NumericTextFieldValidator()
    notBlankValidator = new NotBlankGenericFieldValidator()

    user: User = {} as User

    @Input() viewUserProfile: UserProfile
    @Input() screenMode: string
    @Input() attestedDetails: string
    @Input() isRequired: boolean
    @Input() showEcontract: boolean
    @Input() econtractDisable: boolean
    @Input() isAdminUpdate: boolean

    commissionLevel: ValidatedSelectOptionModel[]
    eContractOnFile: ValidatedSelectOptionModel[] = []
    textMsgOptIn: ValidatedSelectOptionModel[] = []
    chkbox: ValidatedCheckboxComponent

    constructor(formValidationService: FormValidationService, private comLevelGateway: CommissionLevelGateway) {
        super(formValidationService)

        this.getCommissionLevel()
        this.eContractOnFile = [
            { value: '1', text: 'Yes' },
            { value: '0', text: 'No' }
        ]
        this.textMsgOptIn = [
            { value: '1', text: 'Yes' },
            { value: '0', text: 'No' }
        ]
    }

    get profile(): User {
        return this.user
    }

    set profile(value: User) {
        if (value) {
            this.user = value
        }
    }

    getValue(): User {
        return this.user
    }

    getLabel(): string {
        return ''
    }

    ngOnInit(): void {
        if (this.screenMode === 'add') {
            this.isRequired = false
            this.viewUserProfile.ChangePassword = true
        }
    }

    getCommissionLevel() {
        this.comLevelGateway.getAllCommissionLevel('CommLevel').subscribe((comLevelModel: ValidatedSelectOptionModel[]) => {
            this.commissionLevel = comLevelModel
        })
    }

    onBlur() {}
}
